import React from 'react';
import ContentLayout, { H2, Prose } from '../components/ContentLayout';
import SmartImage from '../components/SmartImage';
import IMG_NAMASTE from '../assets/founder/founder-namaste.jpg';
import IMG_MEDITATION from '../assets/founder/founder-meditation-bw.jpg';
import IMG_ARUN from '../assets/founder/founder-with-arun.jpg';
import IMG_ALTAR from '../assets/founder/founder-altar.jpg';
import IMG_GROUP from '../assets/founder/founder-group.jpg';

const AboutFounder = () => (
  <ContentLayout
    testid="page-about-prem"
    eyebrow="Our Founder"
    titleTop="Swami Prem"
    titleItalic="Maitreya"
    intro="A seeker and meditator aspiring to share a life of celebration, love and awareness. After taking sannyas in Osho Neo Sannyas in 2008 from Swami Anand Arun, Swami Prem founded this organization — Meditative Mindfulness Inc."
  >
    <div className="grid md:grid-cols-[1.4fr_1fr] gap-10 items-start">
      <div>
        <H2 top="About Swami Prem" italic="Maitreya" />
        <Prose>
          <p>Swami Prem Maitreya is a highly accomplished entrepreneur, dedicated family man, and committed practitioner of meditation. Originally from India, he now resides in the United States. With a diverse range of meditation practices under his belt — including AOL, Kriya Yoga, Bhakti Yoga, and Osho — he has learned from numerous revered teachers and gurus.</p>
          <p>Through his meditation classes, he generously imparts his wisdom and offers support to those on the path of meditation. In recognition of the importance of self-sufficiency, he has established an organization that aims to empower individuals and foster their independence. His extraordinary journey serves as an inspiring testament to the harmonious integration of modern life and spiritual growth.</p>
          <p>In early life he had a deep inquiry about death and love. His journey became a quest — a deep longing to find what love is. As a young teenager influenced by movies, he thought love was simply convincing another to say “I love you.” Soon after, he realized this brought great pain at heartbreak. In the midst of this confusion he heard a few enlightening words of Osho, and an assurance that there is a love beyond duality — beyond the constant union and separation found in relationships. This inquiry led him to Osho’s books on love: Pad Ghungroo Bandh, Prem Panth, Pivat Pivat Ram Ras, Kabir Vani, Dhai Akshar Prem Ka, Until You Die, and many others.</p>
        </Prose>
      </div>
      <div className="grid gap-4">
        <SmartImage src={IMG_NAMASTE} alt="Swami Prem Maitreya" className="rounded-3xl aspect-[4/3]" />
        <SmartImage src={IMG_MEDITATION} alt="Swami Prem Maitreya in meditation" className="rounded-3xl aspect-[4/3]" />
      </div>
    </div>

    <div className="mt-12">
      <H2 top="Moments on the" italic="path" />
      <div className="grid sm:grid-cols-2 gap-4 mt-4">
        <SmartImage src={IMG_ARUN} alt="Swami Prem Maitreya with Bodhisattva Swami Anand Arun" className="rounded-3xl aspect-[4/3]" />
        <SmartImage src={IMG_GROUP} alt="Swami Prem Maitreya with the sangha" className="rounded-3xl aspect-[4/3]" />
      </div>
    </div>
  </ContentLayout>
);

export default AboutFounder;
